import styled from "styled-components";

export const UnderlineSpan = styled.span`
  //text-decoration: underline;
  //&:hover,
  //&:active {
  //  text-decoration: none;
  //}
`;
